import React from 'react';

export default function Header({ time, theme, mode, onToggle }) {
  const mins = String(Math.floor(time / 60)).padStart(2, '0');
  const secs = String(time % 60).padStart(2, '0');

  return (
    <header style={{ textAlign: 'center', marginBottom: 32, position: 'relative' }}>
      <button onClick={onToggle} style={toggleStyle(theme)} title="Toggle theme">
        {mode === 'light' ? '🌙' : '☀️'}
      </button>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 6 }}>
        <img src="/vite.svg" alt="ShadowMaster" style={{ width: 28, height: 28 }} />
        <span style={{ fontSize: 26, fontWeight: 700, color: theme.text, letterSpacing: '-0.5px' }}>ShadowMaster</span>
      </div>
      <p style={{ margin: 0, fontSize: 13, color: theme.textSub, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        Live Speech Transcript
        <span style={{ background: theme.timerBg, color: theme.timerColor, padding: '2px 10px', borderRadius: 20, fontSize: 12, fontVariantNumeric: 'tabular-nums' }}>
          {mins}:{secs}
        </span>
      </p>
    </header>
  );
}

function toggleStyle(theme) {
  return {
    position: 'absolute', top: 0, right: 0,
    background: theme.toggleBg, color: theme.toggleColor,
    border: 'none', borderRadius: 8, padding: '6px 10px',
    cursor: 'pointer', fontSize: 16, lineHeight: 1,
  };
}
